import axios from 'axios';
import global from '@/global'
import qs from 'qs';
import {
    Message,
    Loading
} from 'element-ui';

const baseURL = global.host + "/";

const ajax = axios.create({
    baseURL,
});
//请求拦截
ajax.interceptors.request.use(req => {

    req.headers['content-type'] = 'application/x-www-form-urlencoded'

    return req
});
//响应拦截
ajax.interceptors.response.use(res => {
    if (res.data.code == 0) {
        return res.data.data;
    } else {
        let msg = res.data.msg || '发生错误'
        Message.error({
            message: msg
        });
        return Promise.reject();
    }

}, error => {
    console.log('响应错误', error.response);
    Message.error({
        message: '数据请求错误'
    });
    return Promise.reject(error);
});

const post = function (url, params = {}) {
    let loadingInstance = null;
    let time = setTimeout(() => {
        loadingInstance = Loading.service({
            lock: true,
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
        });
    }, 500);
    return ajax.post(url, qs.stringify(params)).then(r => r).finally(() => {
        clearTimeout(time);
        if (loadingInstance) {
            loadingInstance.close();
        }
    })
}


export default post